import { render, staticRenderFns } from "./StudyTwoModal.vue?vue&type=template&id=36b927ef&scoped=true"
import script from "./StudyTwoModal.vue?vue&type=script&lang=js"
export * from "./StudyTwoModal.vue?vue&type=script&lang=js"
import style0 from "./StudyTwoModal.vue?vue&type=style&index=0&id=36b927ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b927ef",
  null
  
)

export default component.exports